/**
* 头部菜单
*/
<template>
	<el-menu class="el-menu-demo " mode="horizontal" background-color="#79bbff" text-color="#fff" active-text-color="#fff">

		<el-button class="buttonimg">
			<img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
		</el-button>
		<span class="title">{{title}}</span>

		<el-dropdown trigger="click" class="user">
			<span class="el-dropdown-link u-name">
				您好:{{user.name}}
			</span>



			<el-dropdown-menu slot="dropdown" style="width: 180px;">
				<!-- <el-dropdown-item icon="el-icon-s-custom">个人信息</el-dropdown-item>
        <el-dropdown-item icon="el-icon-edit">修改密码</el-dropdown-item> -->
				<!-- <el-dropdown-item icon="el-icon-circle-plus-outline" @click.native="exit">退出登录</el-dropdown-item> -->
				<el-dropdown-item icon="el-icon-circle-plus-outline" @click.native="exit">退出登录</el-dropdown-item>
				<el-dropdown-item icon="el-icon-key" @click.native="handlePassworld">修改密码</el-dropdown-item>
			</el-dropdown-menu>

		</el-dropdown>

		<!-- <el-popover
			placement="bottom"
			title="提醒"
			width="360"
			trigger="click"
			class="remind"
			v-if="JSON.stringify(remind) != '{}'"
			>
	
			
				<div class="msgBox" v-if="remind.unprice.length || remind.unuser.length">
					<div style="font-weight: bold;">您当前未绑定的电价的电表 ({{remind.unprice.length}})：</div>
					<div v-for="item in remind.unprice">{{item}}</div>
					<el-divider></el-divider>
					<div style="font-weight: bold;">您当前未绑定的用户的电表 ({{remind.unuser.length}}) ：</div>
					<div v-for="item in remind.unuser">{{item}}</div>
				</div>
				<div v-if="remind.unprice.length == 0 && remind.unuser.length == 0"> 您没有消息哦~</div>
				<el-badge :is-dot="remind.unprice.length!=0 || remind.unuser.length!=0" class="item" slot="reference"><i  class="el-icon-bell" style="font-size: 26px; color: #fff;"></i></el-badge>
		</el-popover> -->
		<el-dialog title="修改密码" :visible.sync="showPassWrold" width="35%" @click="closeDialog">
			<el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
				<el-form-item label="原密码" prop="oldPassword">
					<el-input size="small" v-model="editForm.oldPassword" type="password" auto-complete="off" placeholder="请输入用户原密码"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="password">
					<el-input size="small" v-model="editForm.password" type="password" auto-complete="off" placeholder="请输入用户新密码"></el-input>
				</el-form-item>
				<el-form-item label="确认新密码" prop="spassword">
					<el-input size="small" v-model="spassword" type="password" auto-complete="off" placeholder="请输入用户新密码"></el-input>
				</el-form-item>
				
			</el-form>
			<div slot="footer" >
				<el-button size="small" @click="closeDialog">取消</el-button>
				<el-button size="small" type="primary" :loading="setLoading"  @click="submitForm('editForm')">保存</el-button>
			</div>
		</el-dialog>

	</el-menu>
</template>
<script>
	import {
		loginout,
		updateUserInfoPassword
	} from '../api/userMG'
	import {
		mapState
	} from 'vuex'
	export default {
		name: 'navcon',
		data() {
			 var validatePass = (rule, value, callback) => {
					if( this.spassword == '' ){
						callback(new Error('请输入确认密码'));
					}	 
					if (this.editForm.password != this.spassword) {
						callback(new Error('两次密码输入不一致'));
					} else {
						callback();
					}
			 }; 
			return {
				collapsed: true,
				showPassWrold: false,
				setLoading:false,
				spassword:'',
				imgshow: require('../assets/img/show.png'),
				imgsq: require('../assets/img/sq.png'),
				user: {},
				title: "",
				editForm: {
					oldPassword: '',
					password: '',
					uid: '',
				},
				rules:{
					oldPassword: [{
						required: true,
						message: '请输旧密码',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输新密码',
						trigger: 'blur'
					}],
					spassword:[{validator:validatePass,trigger:'change',require:true }]
				}
			}
		},
		// 创建完毕状态(里面是操作)
		created() {
			this.user = JSON.parse(sessionStorage.getItem('userdata'))
			this.title = this.user.departmentName
			this.editForm.uid = this.user.uid
		},
		computed: {
			remind() {
				return this.$store.state.remind
			}
		},

		methods: {
			submitForm(editData){
				this.$refs[editData].validate(valid => {
					if (valid) {
						this.$confirm('确认修改密码?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.setLoading = true
								updateUserInfoPassword(this.editForm).then(res => {
									
									if( res.status == 1){
										this.showPassWrold = false
										this.$message({
											type: 'success',
											message: '密码修改成功'
										})
										loginout().then(res =>{
											if (res.status == 1) {
												//如果请求成功就让他1秒跳转路由
												setTimeout(() => {
													this.$store.commit('logout', 'false')
													this.$router.push({
														path: '/login'
													})
													
												}, 1000)
											} else {
												this.$message.error(res.msg)
												this.logining = false
												return false
											}
										})
										
									}else{
										this.$message.error(res.msg)
										this.setLoading = false
										
									}
								})
							})
						
					} else {
						return false
					}
				})
			},
			handlePassworld() {
				
				this.editForm.oldPassword = ''
				this.editForm.password = ''
				this.showPassWrold = true
			},
			closeDialog() {
				this.showPassWrold = false
			},
			exit() {
				this.$confirm('退出登录, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						
						loginout()
							.then(res => {
								if (res.status == 1) {
									//如果请求成功就让他2秒跳转路由
									setTimeout(() => {
										this.$store.commit('logout', 'false')
                    sessionStorage.setItem('token', '')
										this.$router.push({
											path: '/login'
										})
										this.$message({
											type: 'success',
											message: '已退出登录!'
										})
									}, 1000)
								} else {
									this.$message.error(res.msg)
									this.logining = false
									return false
								}
							})
							.catch(err => {
								// 获取图形验证码
								this.getcode()
								this.logining = false
								this.$message.error('退出失败，请稍后再试！')
							})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						})
					})
			},
			// 切换显示
			toggle(showtype) {
				this.collapsed = !showtype
				this.$root.Bus.$emit('toggle', this.collapsed)
			}
		}
	}
</script>
<style scoped>
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		border: none;
	}

	.el-menu {
		border: none;
	}

	.user {
		float: right;
		color: #FFFFFF;
		border: 0;
		margin-right: 20px;

	}

	.el-submenu__title {
		border: 0;
	}

	.title {

		position: absolute;
		color: #FFFFFF;
		border: 1px solid #fff;
		padding: 3px 12px;
		left: 60px;
		top: 50%;
		transform: translateY(-50%);
		border-radius: 16px;
	}

	.buttonimg {
		height: 60px;
		background-color: transparent;
		border: none;
	}

	.showimg {
		width: 26px;
		height: 26px;
		position: absolute;
		top: 17px;
		left: 17px;
	}

	.showimg:active {
		border: none;
	}

	.el-dropdown-link {
		cursor: pointer;
		line-height: 60px;
		border: 0;
	}

	.el-dropdown-menu__item {}

	.u-name {
		font-size: 16px;
		margin-right: 40px;
	}

	.msgBox {
		height: 500px;
		overflow-y: scroll;
		line-height: 30px;

	}

	.remind {
		position: absolute;
		right: 20px;
		top: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue